import { Box, ListItem, ListItemText, styled } from '@mui/material'

export const StyledBodyModal = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(3, 3, 0, 3),
  maxHeight: 'calc(100vh - 180px)',
  [theme.breakpoints.down('xs')]: {
    paddingRight: '24px',
  },
}))

export const StyledUploadDocSection = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(0, 3),
  margin: '16px 0 24px 0',
  maxHeight: 'calc(100vh - 180px)',
  '& > div > div > div > div': {
    marginTop: '0px',
  },
}))

export const StyledListItem = styled(ListItem)(({ theme }) => ({
  flexWrap: 'wrap',
  padding: 0,
  '& .MuiListItemText-primary': {
    ...theme.typography.subtitle2,
  },
  '& .MuiListItemText-secondary': {
    ...theme.typography.body1,
    color: '#000000',
  },
  [theme.breakpoints.down('xs')]: {
    width: '100%',
  },
}))

export const StyledListItemText = styled(ListItemText)({
  '& > span': { color: '#595959' },
})
